import { ICreateModifierGroupsContext } from './createModifierGroupsContext';

export enum CreateModifierGroupsActionTypes {
	SET_FETCHED_CUSTOMERS = 'SET_FETCHED_CUSTOMERS',
	SET_ID_CUSTOMER = 'SET_ID_CUSTOMER',
	SET_FETCHED_RESTAURANTS = 'SET_FETCHED_RESTAURANTS',
	SET_IDS_RESTAURANT = 'SET_IDS_RESTAURANT',
	CHANGE_NAME_OF_MODIFIER_GROUP = 'CHANGE_NAME_OF_MODIFIER_GROUP',
	CHANGE_EXTERNAL_ID = 'CHANGE_EXTERNAL_ID',
	SET_FETCHED_TRANSLATIONS = 'SET_FETCHED_TRANSLATIONS',
	SET_TRANSLATION_TAB = 'SET_TRANSLATION_TAB',
	CHANGE_TRANSLATION = 'CHANGE_TRANSLATION',
	SET_DATA_FOR_SUBMIT = 'SET_DATA_FOR_SUBMIT',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	RESET_FIELDS = 'RESET_FIELDS',
}

interface ISetFetchedCustomers {
	type: CreateModifierGroupsActionTypes.SET_FETCHED_CUSTOMERS;
	payload: {
		fetchedCustomers: ICreateModifierGroupsContext['fetchedCustomers'];
	};
}

interface ISetIDCustomer {
	type: CreateModifierGroupsActionTypes.SET_ID_CUSTOMER;
	payload: {
		IDSelectedCustomer: ICreateModifierGroupsContext['IDSelectedCustomer'];
	};
}

interface ISetFetchedRestaurants {
	type: CreateModifierGroupsActionTypes.SET_FETCHED_RESTAURANTS;
	payload: {
		fetchedRestaurants: ICreateModifierGroupsContext['fetchedRestaurants'];
	};
}

interface ISetIDsRestaurant {
	type: CreateModifierGroupsActionTypes.SET_IDS_RESTAURANT;
	payload: {
		IDsSelectedRestaurant: ICreateModifierGroupsContext['IDsSelectedRestaurant'];
	};
}

interface IChangeNameOfModifierGroup {
	type: CreateModifierGroupsActionTypes.CHANGE_NAME_OF_MODIFIER_GROUP;
	payload: {
		nameOfModifierGroup: ICreateModifierGroupsContext['nameOfModifierGroup'];
	};
}

interface IChangeExternalId {
	type: CreateModifierGroupsActionTypes.CHANGE_EXTERNAL_ID;
	payload: {
		externalId: ICreateModifierGroupsContext['externalId'];
	};
}

interface ISetFetchedTranslation {
	type: CreateModifierGroupsActionTypes.SET_FETCHED_TRANSLATIONS;
	payload: {
		translations: ICreateModifierGroupsContext['translations'];
		defaultCustomerLanguage: ICreateModifierGroupsContext['defaultCustomerLanguage'];
	};
}

interface ISetTranslationTab {
	type: CreateModifierGroupsActionTypes.SET_TRANSLATION_TAB;
	payload: {
		selectedTranslationTab: ICreateModifierGroupsContext['selectedTranslationTab'];
	};
}

interface IChangeTranslation {
	type: CreateModifierGroupsActionTypes.CHANGE_TRANSLATION;
	payload: {
		translations: ICreateModifierGroupsContext['translations'];
	};
}

interface ISetDataForSubmit {
	type: CreateModifierGroupsActionTypes.SET_DATA_FOR_SUBMIT;
	payload: {
		dataForSubmit: ICreateModifierGroupsContext['dataForSubmit'];
	};
}

interface IChangeTypeOfModalWindow {
	type: CreateModifierGroupsActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: ICreateModifierGroupsContext['typeOfModalWindow'];
	};
}

interface IResetSelectedControls {
	type: CreateModifierGroupsActionTypes.RESET_FIELDS;
}

export type TCreateModifierGroupsAction =
	| ISetFetchedCustomers
	| ISetIDCustomer
	| ISetFetchedRestaurants
	| ISetIDsRestaurant
	| IResetSelectedControls
	| IChangeNameOfModifierGroup
	| IChangeExternalId
	| ISetFetchedTranslation
	| ISetTranslationTab
	| IChangeTranslation
	| ISetDataForSubmit
	| IChangeTypeOfModalWindow;
